import React from 'react';

import { InfoBox } from '@infoods/lifebase-ui';
import classes from './AccountDetailsWidget.module.scss';
import { InfoBlock } from './InfoBlock/InfoBlock';
import { calculateFullYears } from '../../../../shared/utils/dateUtils';

type AccountDetailsWidgetProps = {
  firstName?: string | null;
  lastName?: string | null;
  entityName?: string;
  inbodyId?: string;
  dateOfBirth?: string | null;
  gender?: string | null;
};

const AccountDetailsWidget = ({
  firstName,
  lastName,
  entityName,
  inbodyId,
  dateOfBirth,
  gender,
}: AccountDetailsWidgetProps) => {
  const customerAge = calculateFullYears(dateOfBirth);

  return (
    <InfoBox title="Your Account" customMargin>
      <div className={classes.container}>
        {firstName && lastName && (
          <InfoBlock title="Customer" value={`${firstName} ${lastName}`} />
        )}
        <InfoBlock title="Entity" value={entityName} />
        <div className={classes.innerContainer}>
          <InfoBlock title="ID" value={inbodyId} />
          <InfoBlock title="Age" value={customerAge} />
          <InfoBlock title="Gender" value={gender} />
        </div>
      </div>
    </InfoBox>
  );
};

export { AccountDetailsWidget };
